import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class BillingNotificationService {
    private billingStatusSubject = new Subject<BillingDetailsStatusRaw>();
    private readonly LOCAL_STORAGE_CLOSE_STATE_KEY = 'zp.billing-notification.closed-type';

    constructor(private http: HttpClient) {
    }

    public fetchBillingDetailsStatus() {
        return this.http.get<BillingDetailsStatusRaw>('/publisher/user/billing-details-status')
            .subscribe((status) => {
                this.billingStatusSubject.next(status)
            });
    }

    public get billingStatus$(): Observable<BillingDetailsStatusRaw> {
        return this.billingStatusSubject.asObservable();
    }

    public saveCloseAlertState(status: string, keySuffix: string): void {
        localStorage.setItem(this.LOCAL_STORAGE_CLOSE_STATE_KEY + keySuffix, status);
    }

    public getCloseAlertState(keySuffix: string): string | null {
        return localStorage.getItem(this.LOCAL_STORAGE_CLOSE_STATE_KEY + keySuffix);
    }

    public clearCloseAlertState(keySuffix: string): void {
        localStorage.removeItem(this.LOCAL_STORAGE_CLOSE_STATE_KEY + keySuffix);
    }
}


export enum BillingDetailsStatusRaw {
    VALID = 'VALID',
    SOFT = 'SOFT_WARNING',
    HARD = 'HARD_WARNING',
}

enum BillingDetailsStatusExtended {
    INVALID_BILLING = 'INVALID_BILLING',
}

export const BillingDetailsStatus = { ...BillingDetailsStatusRaw, ...BillingDetailsStatusExtended }
export type BillingDetailsStatus = ValueOf<typeof BillingDetailsStatus>;
